if (process.env.NODE_ENV === "production") {
  if (navigator.userAgent.match(/Macintosh|iPhone|iPad|iOS/i)) {
    FONTPLUS.async();
  }
}
